import { currentLocale } from '../../i18n'

export const num = (v, digits = 0) =>
  v == null ? '—' : new Intl.NumberFormat(currentLocale(), {
    maximumFractionDigits: digits,
  }).format(v)

export function weekLabel(iso) {
  const d = new Date(iso + 'T00:00:00')
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
}

export function monthLabel(year, month) {
  return new Date(year, month - 1, 1)
    .toLocaleDateString(currentLocale(), { month: 'short' })
}

export function monthYearLabel(year, month) {
  return new Date(year, month - 1, 1)
    .toLocaleDateString(currentLocale(), { month: 'long', year: 'numeric' })
}

export function dateLabel(iso) {
  return new Date(iso + 'T00:00:00')
    .toLocaleDateString(currentLocale(), { day: '2-digit', month: 'short', year: 'numeric' })
}

export const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
  + `-${String(d.getDate()).padStart(2, '0')}`

/** The Monday of whatever week `iso` falls in. */
export function mondayOf(iso) {
  const d = new Date(iso + 'T12:00:00')
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7))
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function addWeeks(iso, count) {
  const d = new Date(iso + 'T12:00:00')
  d.setDate(d.getDate() + count * 7)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
